import { render, staticRenderFns } from "./RangeSlide.vue?vue&type=template&id=0fb83f4e&scoped=true&"
import script from "./RangeSlide.vue?vue&type=script&lang=js&"
export * from "./RangeSlide.vue?vue&type=script&lang=js&"
import style0 from "./RangeSlide.vue?vue&type=style&index=0&id=0fb83f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb83f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb83f4e')) {
      api.createRecord('0fb83f4e', component.options)
    } else {
      api.reload('0fb83f4e', component.options)
    }
    module.hot.accept("./RangeSlide.vue?vue&type=template&id=0fb83f4e&scoped=true&", function () {
      api.rerender('0fb83f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/slides/RangeSlide.vue"
export default component.exports